import { HOME_PAGE_KEY } from 'src/pages/pagesKeys';

import {
  // AREA,
  FEATURE_ACTIVATED,
  MIN_WIDTH,
  TOOLBAR_AREA,
  getArea,
  getSecondPage,
} from 'app-customs/config/pagesTwoColumnsConfig';

import { get as getLabels } from 'src/core/Lang';
import { getLocation } from 'src/core/navigation/History';
import { getOrientation } from 'src/core/util/DomTools';
import showConfirmModal from 'src/core/util/showConfirmModal';

let enabled = false;

const isEnabled = () => enabled === true;

function setEnabled(value) {
  if (value !== enabled) {
    console.log(`Two columns mode is now ${enabled ? 'en' : 'dis'}abled`);
  }
  enabled = FEATURE_ACTIVATED && value;
}

const pageHasToolbar = (pageKey) =>
  pageKey !== HOME_PAGE_KEY && (isEnabled() !== true || getArea(pageKey) === TOOLBAR_AREA);

/**
 * After a first page has been mounted, determine which page to mount to fill the other column
 * @param  {string}   displayedPageKey
 * @param  {object}   displayedPageProps
 * @param  {string}   profile
 * @param  {function} navigateAction
 * @return {object}   information about the page displayed
 */
function showSecondPage(displayedPageKey, displayedPageProps, profile, navigateAction) {
  // Determine in which column the first rendered page has been displayed
  // let area = getArea(displayedPageKey);

  // Determine which column is empty
  // let targetArea = area === AREA.left ? AREA.right : AREA.left;

  // then auto-mount in empty column
  const secondPage = getSecondPage(displayedPageKey, displayedPageProps, profile);

  navigateAction(secondPage.pageKey, secondPage.props);

  return secondPage;
}


/**
 * Auto-enable '2 columns mode' if conditions are met
 * @param  {true} shouldReload
 */
function autoEnable(shouldReload) {
  if (FEATURE_ACTIVATED === true) {
    setEnabled(true);
  }
}

export default {
  autoEnable,
  pageHasToolbar,
  isEnabled,
  setEnabled,
  showSecondPage,
};
